<script>
  import {microbaLoader} from '@/services/notificationServices'
  import { kitStatuses } from '@/enums/kitItemStatus'
  import insightReportComparisonWidget from '@microbadevs/insight-report-comparison-widget'
  import ModalOrder from '@/components/models/ModalOrder'
  import ModalSubscription from '@/components/models/ModalSubscription'
  import moment from 'moment'
  const MobileDetect = require('mobile-detect')
  import 'bootstrap-vue/dist/bootstrap-vue.css'
  export default {
    name: 'report-consumer',
    components: {
      insightReportComparisonWidget,
      ModalOrder,
      ModalSubscription
    },
    props: {
      reportId: {
        type: String,
        default: null
      }
    },
    data () {
      return {
        exportURL: process.env.SHOPPING_LIST,
        selectedKit: null,
        showOrderModal: false,
        showSubscriptionModal: false,
        additionalKit: {
          amount: Number(process.env.PRICE_NEW_KIT) || 419.00,
          label: '1 Microba insight kit',
          orderType: 'NEW'
        },
        primarySample: this.reportId ? {identifier: this.reportId} : null,
        secondarySample: null,
        temporarySecondarySample: null,
        compareReport: false,
        actionableLinks: [
          {
            'label': '+ Order another sampling kit',
            'triggerEvent': 'order-another-kit',
            'type': 'actionableLink'
          },
          {
            'label': '+ Activate subscription',
            'triggerEvent': 'activate-subscription',
            'type': 'actionableLink'
          }
        ]
      }
    },
    computed: {
      preSelectionSamples () {
        return [this.reportId]
      },
      isMobile () {
        const mobileDetect = new MobileDetect(window.navigator.userAgent)
        return mobileDetect.mobile()
      },
      selectedOptionTruncateLimit () {
        return this.isMobile ? 8 : 20
      },
      dropdownOptionTuncateLimit () {
        return this.isMobile ? 16 : 16
      },
      userSamples () {
        return this.kits
        .filter(kit => this.listKitStatuses[kit.sampleStatus] === this.listKitStatuses.RESULTS_AVAILABLE)
        .map((kit) => {
          return {
            // @Todo to remove hard coded display date it will come from API.
            label: kit.sampleIdentifier,
            displayName: this.getKitName(kit),
            displayDate: kit.displayDate ? moment(kit.displayDate).format('YYYY-MM-DD') : null,
            id: kit.id,
            identifier: kit.sampleIdentifier
          }
        })
        .filter(kit => kit.displayDate !== null)
      },
      listKitStatuses () {
        return kitStatuses
      },
      user: function () {
        return this.$store.state.GET_USER_RESPONSE
      },
      kits: function () {
        return this.$store.state.GET_KITS_RESPONSE || []
      }
    },
    methods: {
      getKitName (kit) {
        return kit && kit.name ? kit.name
        : kit.activatedDate ? moment(kit.activatedDate).format('MMMM Do')
        : kit.sampleIdentifier
      },
      updatePrimarySample (payload) {
        this.updateSample('primarySample', payload)
      },
      updateSecondarySample (payload) {
        if (!payload) {
          this.updateSample('secondarySample', payload)
        } else {
          this.temporarySecondarySample = payload
        }
      },
      updateSample (sample, payload) {
        switch (sample) {
          case 'primarySample':
            this.primarySample = payload
            break
          case 'secondarySample':
            this.secondarySample = payload
            break
        }
      },
      compareReports () {
        microbaLoader.showLoader()
        setTimeout(() => {
          microbaLoader.hideLoader()
        }, 1000)
        this.secondarySample = this.temporarySecondarySample
      }
    },
    mounted: function () {
      localStorage.setItem('report_path', process.env.API_ROOT_REPORT)
      localStorage.setItem('api_path', process.env.API_ROOT)
      microbaLoader.showLoader()
      this.$store.dispatch('getUserKits')
      .finally(() => {
        microbaLoader.hideLoader()
      })
    }
  }
</script>

<template>
  <!--<transition name="slide-fade">-->
  <div class="page page-report-single">
    <div>
      <template v-if="userSamples.length===0">
        <header>
          <div class="row">
            <h1 class="col-md-8 mb-2 page-header">Microba <em>Insight</em><sup>&trade;</sup> Report</h1>
            <div class="col-12">
              <div class="page-description">
                <strong>Sorry, you have no reports to display at this time.</strong> The Microba <em>Insight</em>&trade;
                Report is a comprehensive report, detailing key information about your personal gut microbiome. You can
                download a copy of your report, and return to the portal as often as you wish to view updates from this
                emerging science.
              </div>

            </div>
            <div class="col-12 col-lg-10 mt-lg-5">
              <img src="@/assets/images/reports-placeholder.png" class="w-100" style="max-width: 400px;">
            </div>
          </div>
        </header>
      </template>
      <div v-else>
        <nav class="navbar sticky-top row">
          <div class='container'>
          <insightReportComparisonWidget
            :actionableLinks='actionableLinks'
            :linkAttachedToSecondary='true'
            :samples="userSamples"
            class='mt-3 col-12'
            :selectedOptionTruncateLimit="selectedOptionTruncateLimit"
            :dropdownOptionTuncateLimit="dropdownOptionTuncateLimit"
            :shoppingOptionsEnabled="true"
            :preSelectionSamples="preSelectionSamples"
            v-on:firstSelectedSampleChanged="updatePrimarySample"
            v-on:secondSelectedSampleChanged="updateSecondarySample"
            v-on:order-another-kit="showOrderModal=true"
            v-on:activate-subscription="showSubscriptionModal=true"
            v-on:compareReports="compareReports"></insightReportComparisonWidget>
            </div>
        </nav>
        <microba-results name="microbaResult" v-if="primarySample" :primarySample="primarySample"
          :secondarySample="secondarySample" :hideHeader="true" :hideName="true" :exportURL="exportURL">
        </microba-results>
        <div v-else class='container'>
            <div class='col-12'>
              <div class='row'>
                <p class='pt-5 col-12 col-lg-9'>To get started select a report from the menu. If you have multiple reports, compare by selecting an earlier report in the first menu and a later report in the second.</p>
              </div>
              <img class='img-fluid pt-md-4 pt-sm-0' src='//assets-microba-prod.microba.com/discover-report-comparison-instructions.png' />
            </div>
        </div>
        <ModalOrder :show="showOrderModal" :product="additionalKit" :giveAway="false" :showIntro="false" heading=""
          title="Confirm your details" copy="Please confirm your details below" @close="showOrderModal = false" />
        <ModalSubscription :show="showSubscriptionModal" :product="additionalKit" heading=""
          @close="showSubscriptionModal = false" />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  // Comparison widget styles
  .insight-report-comparison-widget{
    .badge-primary {
        background-color: #5d4164 !important;
        color: white;
    }
    .badge-secondary {
      background-color: #ff8708 !important;
        color: white;
    }
    .btn-disabled{
      border-radius: 5px;
    }
    .form-group-select{
      margin: 0;
      .v-select{
        .dropdown-toggle{
          .clear{
            display:initial;
            span {
              font-size: 40px;
              margin-right: 20px;
            }
          }
          .open-indicator{
            margin-right: 20px;
            &:before{
              border-color: #5E3F63;
            }
          }
          border:none;
        }
        // styling for purchase options dropdown on comparison widget without sample A selected
        .dropdown-menu{
          // background-color:pink;
          border: none;
          .sampleItem{

            .displayName{
            }
            .displayDate{
              color: #bababa;
            }
          }
          .no-options{
            // background-color: lightblue;
            text-align: left;
            hr{
              margin: 0;
            }
            span{
              div{
                font-size: 1.2em;
                padding: 10px 10px 10px 30px;
                cursor: default;
                &.block{
                  cursor: pointer;
                  color: #9FA5B1;
                  &:hover{
                    background-color: #E8ECED;
                    color: #38455D;
                    font-weight: 400;
                  }
                }
              }
              div:nth-child(2) {
                // background-color: lightblue;
                // font: italic bold 1.3em serif;
              }
            }
          }
        }
        // styling for purchase options dropdown on comparison widget with sample A selected
        .dropdown-menu{
          .highlight{
            a {
              background: none;
            }
          }
          a {
            color: black;
            font-size: 1.2em;
            font-weight: lighter;
            text-transform: none;
            padding: 0;
            &:hover {
              background: #E8ECED;
              color: white;
            }
            .sampleItem {
              padding: 10px 10px 10px 30px;
              &:hover {
                background: #5897fb;
                .displayDate{
                  color: white;
                }
              }
            }
            .linkItem {
              padding: 10px 10px 10px 30px;
              color: #9FA5B1;
              &:hover {
                color: #38455D !important;
                font-weight: 400;
              }
            }
          }
        }
      }
    }
  }

    .sampleSelectionInformatic{
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  // AB pill badget styles for two samples
  .page-report-single .badge-pill {
    color: white;
  }
</style>
<style scoped lang="scss">
  nav{
    background: #e4e7ea;
  }
</style>



// WEBPACK FOOTER //
// src/application/customer/ReportsSingle.vue